import { useTranslation } from 'react-i18next'

import { REQUEST_ENTITY } from '../../../../constants/entity'
import { SUBMENU_DEFAULT_VALUE } from '../../../../constants/route'
import Button from '../../../Button'
import { FILTER_BAR_FILTER_TRIGGER_VARIANT, FilterBar } from '../../../Filter'
import {
  REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_BUTTON_TEXT_KEY,
  REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_FILTER_BAR_ITEMS_PROPS,
  REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_QA_NAME,
} from '../RequestProfileTabAttachedRequests.constants'

import * as styles from './RequestProfileTabAttachedRequestsToolbar.module.css'

import EditIcon from '../../../../icons/edit.svg'
import LeaveIcon from '../../../../icons/leave.svg'
import PlusIcon from '../../../../icons/plus.svg'

function RequestProfileTabAttachedRequestsToolbar({
  availableFilters,
  canCreateRelatedRequest,
  canEditRelatedRequests,
  filterValues,
  isSkeleton,
  ordering,
  pagination,
  requestId,
  setFilterValues,
  shouldReloadValues,
  onChangeShouldReloadValues,
  onClickAttach,
  onClickDeattach,
  onClickMassEdit,
  onReload,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.toolbar}>
      <FilterBar
        responsive
        availableFilters={availableFilters}
        className={styles.filterBar}
        entity={REQUEST_ENTITY}
        filterBarItemsProps={
          REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_FILTER_BAR_ITEMS_PROPS
        }
        filterTriggerVariant={FILTER_BAR_FILTER_TRIGGER_VARIANT.COMPACT_ICON}
        filterValues={filterValues}
        isSkeleton={isSkeleton}
        objectId={requestId}
        ordering={ordering}
        pagination={{ per_page: pagination?.pageSize }}
        setFilterValues={setFilterValues}
        shouldReloadValues={shouldReloadValues}
        singleFieldApiParams={{ connected_request_id: requestId }}
        sub={SUBMENU_DEFAULT_VALUE}
        onChangeShouldReloadValues={onChangeShouldReloadValues}
        onReload={onReload}
      />
      <div className={styles.actions}>
        {canEditRelatedRequests ? (
          <Button.Text
            beforeIconProps={{ Icon: EditIcon }}
            className={styles.actionButton}
            isSkeleton={isSkeleton}
            qaName={REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_QA_NAME.massEdit}
            text={t(
              REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_BUTTON_TEXT_KEY.massEdit
            )}
            textClassName={styles.buttonText}
            onClick={onClickMassEdit}
          />
        ) : null}
        {canEditRelatedRequests ? (
          <Button.Text
            beforeIconProps={{ Icon: LeaveIcon }}
            className={styles.actionButton}
            isSkeleton={isSkeleton}
            qaName={REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_QA_NAME.deattach}
            text={t(
              REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_BUTTON_TEXT_KEY.deattach
            )}
            textClassName={styles.buttonText}
            onClick={onClickDeattach}
          />
        ) : null}
        {canCreateRelatedRequest ? (
          <Button.Text
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.actionButton}
            isSkeleton={isSkeleton}
            qaName={REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_QA_NAME.attach}
            text={t(
              REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_BUTTON_TEXT_KEY.attach
            )}
            textClassName={styles.buttonText}
            onClick={onClickAttach}
          />
        ) : null}
      </div>
    </div>
  )
}

export default RequestProfileTabAttachedRequestsToolbar
